<template>
  <div class="prizes-2021-game-place-description">
    <div class="prizes-2021-game-place-description__title">
      Апгрейд игрового места
    </div>
    <a
      href="https://bit.ly/hyperPC_rr_g"
      target="_blank"
      class="prizes-2021-game-place-description__subtitle"
    >
      HYPERPC GAMING X3 на базе Intel®️ Core™️ i7 и NVIDIA GeForce RTX 3080
    </a>
    <ul class="prizes-2021-game-place-description__list">
      <li>
        <a href="https://clc.am/H500M" target="_blank" rel="noopener"
          >корпус Cooler Master</a
        >
      </li>
      <li>
        <a href="https://clc.am/ML240R" target="_blank" rel="noopener"
          >кулер Cooler Master</a
        >
      </li>
      <li>
        <a href="https://clc.am/vGold750" target="_blank" rel="noopener"
          >блок питания Cooler Master</a
        >
      </li>
      <li>
        <a href="https://clc.am/chair1" target="_blank" rel="noopener"
          >игровое кресло Cooler Master</a
        >
      </li>
      <li>
        <a
          href="https://hyperx.gg/RBRR_Revolver71"
          target="_blank"
          rel="noopener"
          >игровые наушники HyperX</a
        >
      </li>
      <li>
        <a href="https://hyperx.gg/RBRR_QuadCast" target="_blank" rel="noopener"
          >микрофон HyperX</a
        >
      </li>
      <li>
        <a href="https://bit.ly/AOC_rr_1" target="_blank" rel="noopener"
          >игровой монитор от AOC</a
        >
      </li>
      <li>
        <a href="https://hyperx.gg/RBRR_Haste" target="_blank" rel="noopener"
          >игровая мышь HyperX</a
        >
      </li>
      <li>
        <a href="http://bit.ly/hyperX_rr" target="_blank" rel="noopener"
          >коврик для мыши HyperX</a
        >
      </li>
      <li>
        <a
          href="https://hyperx.gg/RBRR_AlloyElite2"
          target="_blank"
          rel="noopener"
          >клавиатура HyperX</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Prizes2021GamePlaceDescription"
};
</script>

<style lang="scss">
.prizes-2021-game-place-description {
  flex: 0 0 0;
  margin-left: 40px;

  &__title {
    font-size: 51px;
    font-weight: 800;
    line-height: 1.15;
  }

  &__subtitle {
    margin-top: 2em;
    font-size: 16px;
    font-weight: 700;
    color: #fff;
  }

  &__list {
    margin-top: 2.2em;
    list-style: none;
    color: darken(#fff, 25%);
    line-height: 1.75;
    font-size: 13px;

    a {
      color: inherit;
      font-weight: inherit;
    }

    li::before {
      content: "— ";
    }
  }

  @include breakpoint("md-and-down") {
    &__title {
      font-size: 45px;
    }
    &__subtitle,
    &__list {
      font-size: 12px;
    }
  }

  @include breakpoint("sm-and-down") {
    flex-basis: 210px;
    margin-left: 25px;
    padding-right: 20px;
    &__title {
      font-size: 32px;
    }
    &__subtitle {
      font-size: 13px;
    }

    &__list {
      font-size: 11px;
    }
  }

  @include breakpoint("xs-only") {
    padding-right: 10px;
    padding-left: 10px;
    margin-left: 0;
    &__title {
      font-size: 18px;
    }
  }
}
</style>
